import React from 'react';
const { PUBLIC_URL } = process.env;
const ViewDemo = ({ match }) => {
  const demoId = match.params.id; // Access the id parameter from the URL

  // Replace this with your own logic to fetch the appropriate GIF based on the gifId

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>App Demo</h1>
      <video src={`${PUBLIC_URL}/videos/${demoId}.mp4`} controls style={styles.video} />
    </div>
  );
};

export default ViewDemo;

// Define the styles object
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
  },
  heading: {
    marginBottom: '20px',
    fontSize: '24px',
  },
  video: {
    height: '70vh',
  }
};
